<template>
  <div>
    <div
      ref="modal"
      class="modal"
      :class="{ show: showModal, 'd-block': showModal }"
      tabindex="-1"
      role="dialog"
      :style="getOptionalStyles('modal')"
      @click="clickOutside"
    >
      <!-- <transition name="modal"> -->
      <div class="modal-wrapper" :style="getOptionalStyles('modal-wrapper')">
        <div
          class="modal-dialog modal-dialog-scrollable"
          :class="size"
          :style="getOptionalStyles('modal-dialog')"
        >
          <div
            class="modal-content"
            :style="getOptionalStyles('modal-content')"
          >
            <div
              class="modal-header pb-0 align-items-start"
              :style="getOptionalStyles('modal-header')"
            >
              <h5 v-if="hasHeaderSlot" class="modal-title w-100">
                <slot name="optionalPhoto"></slot>
                <slot name="header"></slot>
              </h5>
              <div v-else class="w-100"></div>
              <button
                type="button"
                class="btn-close m-0"
                data-cy="close-modal-button"
                aria-label="Close"
                @click="closeModal"
                v-if="closeable"
                :style="getOptionalStyles('modal-close')"
              ></button>
            </div>
            <div
              class="modal-body py-0 px-4"
              :class="{ 'modal-body-mh': restrictBodyHeight }"
            >
              <slot name="body"> Default body </slot>
            </div>
            <div>
              <slot name="optional-image"></slot>
            </div>
            <template v-if="hasFooterSlot">
              <slot name="footer"></slot>
            </template>
            <template v-else>
              <!-- Default Footer -->
              <div class="modal-footer" v-if="saveButton">
                <a
                  href="javascript:"
                  style="margin-right: 20px"
                  @click="closeModal"
                  >Cancel</a
                >
                <button
                  type="button"
                  @click="$emit('save')"
                  class="btn btn-primary"
                >
                  Save
                </button>
              </div>
              <div class="modal-footer" v-else-if="customFooter"></div>
              <div class="modal-footer" v-else>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  @click="closeModal"
                  class="btn btn-primary btn-sm"
                >
                  {{ closeButton ? "Close" : "Continue" }}
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- </transition> -->
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    optionalStyles: Object,
    showModal: Boolean,
    saveButton: Boolean,
    closeButton: Boolean,
    customFooter: Boolean,
    closeable: { default: true, type: Boolean },
    size: { default: "modal-lg", type: String },
    restrictBodyHeight: { default: true, type: Boolean },
    closeOnOutsideClick: { type: Boolean, default: false },
  },
  emits: ["close", "save"],
  computed: {
    hasHeaderSlot() {
      const hasHeader = !!this.$slots['header'] && this.$slots['header']()?.length > 0
      const hasOptionalPhoto = !!this.$slots['optionalPhoto'] && this.$slots['optionalPhoto']()?.length > 0

      return hasHeader || hasOptionalPhoto
    },
    hasFooterSlot() {
      return !!this.$slots['footer'];
    },
  },
  mounted() {
    // block body scroll when modal showed by default as watcher won't work in this case
    if (this.showModal) {
      document.documentElement.style.overflow = "hidden";
      document.body.scroll = "no";
    }
  },
  beforeUnmount () {
    // when modal became destroyed and still active, make sure that scroll behaviour is reverted to normal.
    if (this.showModal && document?.documentElement?.style?.overflow === 'hidden') {
      document.documentElement.style.overflow = "scroll";
      document.body.scroll = "yes";
    }
  },
  watch: {
    showModal(val, oldVal) {
      if (val !== oldVal) {
        if (val === true) {
          document.documentElement.style.overflow = "hidden";
          document.body.scroll = "no";
        } else {
          document.documentElement.style.overflow = "scroll";
          document.body.scroll = "yes";
        }
      }
    },
  },
  methods: {
    getOptionalStyles(className) {
      if (this.optionalStyles && this.optionalStyles[className]) {
        return this.optionalStyles[className];
      }
      return "";
    },
    closeModal() {
      document.documentElement.style.overflow = "scroll";
      document.body.scroll = "yes";
      this.$emit("close");
    },
    clickOutside(e) {
      if (!this.closeOnOutsideClick) {
        return
      }

      const modalContent = this.$el?.querySelector('.modal-content')
      if (!modalContent) {
        return
      }

      if (modalContent?.contains(e.target) === false && this.$el?.contains(e.target)) {
        this.closeModal()
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "lendio-modals";
.btn-close {
  font-size: 10px;
}
.modal {
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}
.modal-m.finicity-modal {
  .modal-content {
    min-height: calc(98vh - 60px);
  }
  .modal-header {
    display: none;
  }
}

@media (max-width: 500px) {
  .modal-content {
    max-width: 400px;
  }
}
@media (max-width: 380px) {
  .modal-content {
    max-width: 334px;
  }
}
@media (max-width: 335px) {
  .modal-content {
    max-width: 300px;
  }
}
</style>
